import { useState, useEffect } from "react";
import { Container, Row, Col, Card,Button } from "react-bootstrap";
import axiosInstance from "../../utils/axiosUtil";
import { getError } from "../../utils/error";
import LoadingBox from "../layout/LoadingBox";
import MessageBox from "../layout/MessageBox";
import { useNavigate } from "react-router-dom";

export default function SampleRequests() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
   const navigate = useNavigate();
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 50,
    total: 0,
    pages: 0,
  });

  useEffect(() => {
    fetchRequests();
  }, []);

  const fetchRequests = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await axiosInstance.get(
        "/sample-requests?page=1&limit=50"
      );

      setRequests(response.data.requests || []);
      setPagination(response.data.pagination || pagination);
    } catch (err) {
      setError(getError(err));
      console.error("Error fetching sample requests:", err);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  

  return (
    <Container fluid className="page-section py-4">
      <Row className="mb-4">
        <Col md={12}>
          <h3 className="page-title">Sample &amp; Buy Now Requests</h3>
          <p className="page-subtitle mb-0">
            View and manage all requests — free sample downloads and buy now enquiries.
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card>
            <Card.Body>
              {error && <MessageBox variant="danger">{error}</MessageBox>}
              {message && <MessageBox variant="success">{message}</MessageBox>}

              {loading ? (
                <div className="py-4 text-center">
                  <LoadingBox />
                </div>
              ) : requests.length === 0 ? (
                <div className="text-center py-5">
                  <p className="text-muted">No sample requests found.</p>
                </div>
              ) : (
                <>
                  <div className="table-responsive">
                    <table className="table table-striped table-hover w-full">
                      <thead>
                        <tr>
                          <th>Type</th>
                          <th>Date</th>
                          <th>Name</th>
                          <th>Company</th>
                          <th>Designation</th>
                          <th>Country</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {requests.map((request) => (
                          <tr key={request._id}>
                            <td>
                              {request.requestType === "buy now" ? (
                                <span style={{ backgroundColor: "#198754", color: "#fff", fontSize: "0.75rem", padding: "3px 10px", borderRadius: "12px", display: "inline-block", fontWeight: 600 }}>
                                  💰 Buy Now
                                </span>
                              ) : (
                                <span style={{ backgroundColor: "#0d6efd", color: "#fff", fontSize: "0.75rem", padding: "3px 10px", borderRadius: "12px", display: "inline-block", fontWeight: 600 }}>
                                  📄 Sample
                                </span>
                              )}
                            </td>
                            <td>{formatDate(request.createdAt)}</td>
                            <td>{request.name ? request.name : "_"}</td>
                            <td>{request.company ? request.company : "_"}</td>
                            <td>
                              {request.designation ? request.designation : "_"}
                            </td>
                            <td>{request.country ? request.country : "_"}</td>
                            <td>
                              <Button
                                variant="light"
                                className="btn-ghost-primary btn-sm"
                                onClick={() => navigate(`/admin/sample-requests/${request._id}`)}
                              >
                                View details
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {pagination.pages > 1 && (
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <div>
                        Showing {(pagination.page - 1) * pagination.limit + 1}{" "}
                        to{" "}
                        {Math.min(
                          pagination.page * pagination.limit,
                          pagination.total
                        )}{" "}
                        of {pagination.total} requests
                      </div>
                    </div>
                  )}
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
